import axios from 'axios';
import { store } from './redux/store';
import { API_URL } from './config/apiConfig';
import { expireSession, refreshSession, sessionIsCurrent } from './utils/sessionRefresh';

const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use(config => {
  const { token, sessionId } = store.getState().auth;
  if (config._retry && !sessionIsCurrent(config._sessionId)) throw new axios.CanceledError('Sessão alterada.');
  config._sessionId = sessionId;
  config._accessToken = token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});
api.interceptors.response.use(response => {
  if (response.config._sessionId && !sessionIsCurrent(response.config._sessionId)) throw new axios.CanceledError('Sessão alterada.');
  return response;
}, async error => {
  const request = error.config;
  if (error.response?.status !== 401 || !request || request.skipAuthRefresh) return Promise.reject(error);
  if (!sessionIsCurrent(request._sessionId)) return Promise.reject(error);
  if (request._retry) { expireSession(request._sessionId); return Promise.reject(error); }
  request._retry = true;
  if (store.getState().auth.token === request._accessToken) await refreshSession();
  if (!sessionIsCurrent(request._sessionId)) throw new axios.CanceledError('Sessão alterada.');
  return api(request);
});
export default api;
